module.exports = __webpack_public_path__ + "static/media/pr12.fd6d8dcb.ogg";